export const Svg_104 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M16.77 64.167v-4.375h16.042V46.667H26.25c-4.035 0-7.474-1.422-10.318-4.266-2.844-2.843-4.266-6.283-4.266-10.317 0-2.917.802-5.603 2.406-8.058 1.605-2.454 3.768-4.24 6.49-5.359.438-3.646 2.03-6.696 4.776-9.151C28.085 7.061 31.305 5.834 35 5.834c3.694 0 6.914 1.227 9.661 3.682s4.339 5.505 4.776 9.151c2.722 1.118 4.886 2.905 6.49 5.36 1.604 2.454 2.406 5.14 2.406 8.057 0 4.034-1.422 7.474-4.266 10.317-2.843 2.844-6.283 4.266-10.317 4.266h-6.563v13.125h16.77v4.375H16.77Zm9.48-21.875h17.5c2.835 0 5.245-.992 7.23-2.977 1.986-1.985 2.978-4.396 2.978-7.231a9.55 9.55 0 0 0-1.75-5.578 10.774 10.774 0 0 0-4.52-3.756l-2.334-1.02-.292-2.553c-.34-2.576-1.463-4.715-3.367-6.416-1.905-1.702-4.137-2.552-6.695-2.552-2.559 0-4.79.85-6.695 2.552-1.905 1.701-3.028 3.84-3.368 6.416l-.292 2.553-2.333 1.02c-1.847.827-3.354 2.084-4.52 3.772-1.167 1.688-1.75 3.545-1.75 5.57 0 2.814.992 5.217 2.977 7.21 1.985 1.993 4.395 2.99 7.23 2.99Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={22.458}
        x2={52.434}
        y1={14.584}
        y2={53.395}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)